import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

import Agents from "./Agents";
import Departments from "../departments/Departments";
import AgentSidebar from "./AgentSidebar";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Swal from 'sweetalert2';

import {removeAgents} from "../../actions/actions";
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class AgentList extends Component {

    constructor(props) {
        super(props);
        this.state = {sidebarAgentID: 0,sidebarData:[],isToggleSidebar: false};
        this.openAgentDetail = this.openAgentDetail.bind(this);
        this.removeAgent = this.removeAgent.bind(this);
        this.editAgent = this.editAgent.bind(this);

    }
    openAgentDetail(e,id){
        this.setState({
            sidebarAgentID: id,
            isToggleSidebar:true
        });

        this.props.chatprop.allAgents.filter(agent => agent.id == id).map(filteredAgent => (
            this.setState({
                sidebarData:filteredAgent
            })
        ))

        e.preventDefault();
    }
    editAgent(e,id){
        this.props.dispatch({
            type: 'SET_MODAL',
            data: {
                "show":true,
                "page":"editAgent",
                "data":{
                    id :id
                }
            }
        });
        e.preventDefault();
    }
    removeAgent(e,id){
        Swal.fire({
            title: 'Are you sure you want to delete ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.dispatch(removeAgents(id));
            }
        });
        e.preventDefault();
    }
    componentDidMount() {
        this.props.dispatch({
            type: 'SET_MENU',
            data: "agents"
        });
    }


    render() {
        const { t } = this.props;


            return (
                <>
                    <div className="agent-list chat  d-flex align-items-center justify-content-center " id="middle">

                        <div className="sidebar-body" id="chatsidebar">

                            <nav>
                                <Tabs defaultActiveKey="agents">
                                    <Tab eventKey="agents" title="Agents">
                                        {typeof this.props.chatprop.allAgents !== "undefined" &&
                                            <Agents openAgentDetail={this.openAgentDetail} editAgent={this.editAgent}  removeAgent={this.removeAgent} />
                                        }
                                    </Tab>
                                    <Tab eventKey="departments" title="Departments">
                                        {typeof this.props.chatprop.allDepartments !== "undefined" &&
                                            <Departments />
                                        }
                                    </Tab>

                                </Tabs>
                            </nav>

                        </div>

                    </div>
                    <div className="sidebar-group left-sidebar chat_sidebar"
                         style={{display: this.state.isToggleSidebar ? 'block' : 'none'}}>
                        <AgentSidebar  agent_id={this.state.sidebarAgentID}/>
                    </div>

                </>

            )

    }
}

export default withTranslation()(AgentList);
